import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message, Button } from 'semantic-ui-react'
// import _find from 'lodash/find';
import _ from 'lodash';

//utils
import queries from '../../../utils/queries'

import general from '../../../modulos/general';
import ListaDe from '../../../components/funcionales/dirmayor/listade';
import ListaCi from '../../../components/funcionales/dirmayor/listaci';
import selciudad from '../../../functions/selciudad';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

// "use strict";

//dropdown PROCESOS DE FACT
const DetalleNivel1PF = props => {
  return (
    <option dato1={props.elemento.observaciones} dato2={props.elemento.codProcFact}
        value={props.elemento._id} style={props.styles.input}>{props.elemento.descrDpto} ={">"} {props.elemento.nombreCiudad} ={">"} {props.elemento.descrClaseServ} ={">"} RANGO: {props.elemento.factInicial} - {props.elemento.factFinal} ={">"} CICLO: {props.elemento.cicloFact}</option>
  )
};

const ListaPF = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1PF styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="proceso" id="miListaPF"  onChange={(ev)=>handleChange(ev)}>
        <option style={styles.input} value="">Todos...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown PROCESOS DE FACT

//dropdown CICLOS FACTURACION
const DetalleCF1 = props => {
  return (
    <option dato1={props.elemento._id} value={props.elemento.cicloFact} style={props.styles.input}>{props.elemento.cicloFact}</option>
  )
};

const ListaCF = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleCF1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="cicloFact" id="miListaCF" onChange={(ev)=>handleChange(ev)}>
        <option value="">Todos...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown CICLOS DE FACTURACION

//dropdown CLASES
const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.codigoClaseServ} value={props.elemento._id} style={props.styles.input}>{props.elemento.descrClaseServ}</option>
  )
};

const Lista = ({styles, handleLista4, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="clase" id="miLista4" onChange={handleLista4} onClick={(ev)=>handleChange(ev)}>
        <option style={styles.input} value="">Todas...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown CLASES
//Lista de gestion recaudo
const RdoDet = ({elemento}) => {
return(
    <tr className=''>
    <td className=''>{elemento.descrRecurso}</td>
    <td className='right aligned'>{general.formatNum(elemento.valorFacturado.toString())}</td>
    <td className='right aligned'>{general.formatNum(elemento.saldoAnterior.toString())}</td>
    <td className='right aligned'>{general.formatNum(elemento.valorFactura.toString())}</td>
    <td className='right aligned'>{general.formatNum(elemento.clientesFact.toString())}</td>
    <td className='right aligned'>{general.formatNum(elemento.recaudoTro.toString())}</td>
    <td className='right aligned'>{general.formatNum(elemento.clientesTro.toString())}</td>
    <td className='right aligned'>{general.formatNum(elemento.recaudoOf.toString())}</td>
    <td className='right aligned'>{general.formatNum(elemento.clientesOf.toString())}</td>
    </tr>
  )
};

const ListaRdo = ({list}) => {
  const nivel1Detalle = list.map((elemento, i) => <RdoDet elemento={elemento} key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};
//Fin lista de gestion recaudo
//Lista edad de mora
const EdadDet = ({elemento}) => {
  return(
      <tr className=''>
      <td className=''>{elemento.descrRecurso}</td>
      <td className='right aligned'>{general.formatNum(elemento.rango1Ac.toString())}</td>
      <td className='right aligned'>{general.formatNum(elemento.rango2Ac.toString())}</td>
      <td className='right aligned'>{general.formatNum(elemento.rango3Ac.toString())}</td>
      <td className='right aligned'>{general.formatNum(elemento.rango4Ac.toString())}</td>
      <td className='right aligned'>{general.formatNum(elemento.rango1DX.toString())}</td>
      <td className='right aligned'>{general.formatNum(elemento.rango2DX.toString())}</td>
      <td className='right aligned'>{general.formatNum(elemento.rango3DX.toString())}</td>
      <td className='right aligned'>{general.formatNum(elemento.rango4DX.toString())}</td>
      </tr>
    )
  };

  const ListaEdad = ({list}) => {
    const nivel1Detalle = list.map((elemento, i) => <EdadDet elemento={elemento} key={i}/>);
    return(
      <tbody className=''>
        {nivel1Detalle}
      </tbody>
    )
  };
//Fin lista edad de mora
  

let fechaHoy = new Date()
let fechaIni = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-01'
fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())

// argsBuscarCL.estadoCliente='XXX'
const argsBuscarCL = {estadoCliente: 'XXX'}
let argsBuscarCLRte = {tipoqry: `[{$match: {estadoCliente: "NUEVO"}}]`}

const argsBuscarMC = {tipo: "X"}

let argsBuscarPC = {tipoqry: `[{$match: {fechaPago: { $gte: new Date("2019-04-07"), $lte: new Date("2019-04-07") }}},{$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}}]`}
let argsBuscarFact = {tipoqry: `[{$match: {fechaMov: { $gte: new Date("2019-04-07"), $lte: new Date("2019-04-07") }}}]`}

class RtesGesTro2 extends React.Component {
  state={argsDocum: {_id: "", desde: fechaIni, hasta: fechaHoy, desdeF: fechaIni, hastaF: fechaHoy,
          descrDpto: "Todos...", nombreCiudad: "Todas...", cicloFact: "Todos..."},
        argsSelDpto: this.props.argsSelDpto, listPagos: [], listEdad: [], errors: []}

  handleChange = (ev) => {
    const argsDocum = this.state.argsDocum
    if(ev.target.name==="proceso"){
      var miLista = document.getElementById("miListaPF");
      // this.setState({observaciones: miLista.options[miLista.selectedIndex].attributes[0].value})
    }else{
      argsDocum[ev.target.name] = ev.target.value
    }
// console.log(argsDocum)
    let listPagos = [], listEdad = []
    this.setState({listPagos, listEdad})
    this.setState({argsDocum});
  }

  handleSubmit = async (ev, argsDocum, argsSelDpto)=>{
    // console.log(ev.target.name)
    // console.log(argsDocum)
    let targetName = ev.target.name
    
    if(targetName==="pantalla"&&this.props.permiteOpcion1){
      document.body.style.cursor = 'wait'
    // let fechaHoy = new Date()
    // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
    let argsUpd
    let errors = []
    if(!argsDocum.desde){
      errors.push({path: "Desde", message: "Debe seleccionar la fecha inicial del recaudo"});
    }
    if(!argsDocum.hasta){
      errors.push({path: "Hasta", message: "Debe seleccionar la fecha final del recaudo"});
    }
    if(!argsDocum.desdeF){
      errors.push({path: "Desde", message: "Debe seleccionar la fecha inicial de procesos de facturación"});
    }
    if(!argsDocum.hastaF){
      errors.push({path: "Hasta", message: "Debe seleccionar la fecha final de procesos de facturación"});
    }
    // console.log(argsDocum)
    this.setState({errors})
    if(errors.length===0){
//FACTURACION
      var miLista = document.getElementById("miListaPF");

      let argsBuscarFact = `fechaMov: { $gte: new Date('${argsDocum.desdeF}'), $lte: new Date('${argsDocum.hastaF}') }, 
            'codProcFact': {$ne: 'ANULADA'}, 'tipoGen': 'proceso'`
      if(miLista.options[miLista.selectedIndex].text!=="Todos..."){
        if(argsBuscarFact){argsBuscarFact += `, `}
        argsBuscarFact += `'codProcFact': '${miLista.options[miLista.selectedIndex].attributes[1].value}'`
      }

      if(!argsSelDpto.descrDpto||argsSelDpto.descrDpto==="Todos..."){

      }else{
        if(!argsSelDpto.nombreCiudad||argsSelDpto.nombreCiudad==="Todas..."){
          if(argsBuscarFact){argsBuscarFact += `, `}
          argsBuscarFact += `'descrDpto': '${argsSelDpto.descrDpto}'`
        }else{
          if(argsBuscarFact){argsBuscarFact += `, `}
          argsBuscarFact += `'descrDpto': '${argsSelDpto.descrDpto}', 'nombreCiudad': '${argsSelDpto.nombreCiudad}'`
        }
      }

      argsBuscarFact = '{' + argsBuscarFact + '}'
      let tipoqry = `[{$match: ${argsBuscarFact}},`

      tipoqry += ` {"$unwind":"$detalleFact"},`
      if(argsSelDpto.descrClaseServ&&argsSelDpto.descrClaseServ!=="Todas..."){
        tipoqry += `{$match: {'detalleFact.descrClaseServ': '${argsSelDpto.descrClaseServ}'}},`
      }
      if(argsDocum.cicloFact&&argsDocum.cicloFact!=="Todos..."){
        tipoqry += ` {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}},`
        tipoqry += ` {"$unwind": "$cliente"},`
        tipoqry += ` {$match: {'cliente.cicloFact': '${argsDocum.cicloFact}'}},`
      }

      argsBuscarFact = {tipoqry: `${tipoqry}
        {$project: {'numeroFra': 1, 'descrRecurso': 1, 'valorFactura': 1, 'valorF': '$detalleFact.valor'}},
        {$group: {_id: {numeroFra: '$numeroFra', descrRecurso: '$descrRecurso', valorFactura: '$valorFactura'},
                  valorF: {$sum: '$valorF'}}},
        {$unwind:"$_id"},
        {$group: {_id: {descrRecurso: '$_id.descrRecurso'}, cuenta: { $sum: 1 },
                  valorF: {$sum: '$valorF'}, valorFactura: {$sum: '$_id.valorFactura'}}},
        {$unwind:"$_id"},
        {$sort: {_id: 1}},
        {$project: {_id: 0, totFras: {$toInt: '$cuenta'}, 'descrRecurso': '$_id.descrRecurso', 
        valorFactura: {$toLong: '$valorFactura'}, valorFacturado: {$toLong: '$valorF'}}}
      ]`}
      // console.log(argsBuscarFact)
      let clientesFact = []
      if(this.props.allFactRtesGroup.allFactRtesGroup){
        let {data} = await this.props.allFactRtesGroup.refetch(argsBuscarFact)
        clientesFact = await data.allFactRtesGroup
      }
// console.log(clientesFact)

//RECAUDO
      let argsBuscarPC = `fechaPago: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${argsDocum.hasta}') }, 
        'documento': {$ne: 'ANULADO'}`
      argsBuscarPC = '{' + argsBuscarPC + '}'
      tipoqry = `[{$match: ${argsBuscarPC}},`

      tipoqry += ` {$lookup: {from: 'clientes', localField: 'contrato', foreignField: 'contrato', as: 'cliente'}},`
      tipoqry += ` {"$unwind": "$detalle"},`
      tipoqry += ` {"$unwind": "$cliente"},`
      tipoqry += ` {$match: {'cliente.estadoCliente': {$ne: 'NUEVO'}`
      if(argsDocum.cicloFact&&argsDocum.cicloFact!=="Todos..."){
        tipoqry += `, 'cliente.cicloFact': '${argsDocum.cicloFact}'`
      }

      if(!argsSelDpto.descrDpto||argsSelDpto.descrDpto==="Todos..."){

      }else{
        if(!argsSelDpto.nombreCiudad||argsSelDpto.nombreCiudad==="Todas..."){
          tipoqry += `, 'cliente.dirmayor.descrDpto': '${argsSelDpto.descrDpto}'`
        }else{
          tipoqry += `, 'cliente.dirmayor.descrDpto': '${argsSelDpto.descrDpto}',
            'cliente.dirmayor.ciudades.nombreCiudad': '${argsSelDpto.nombreCiudad}'`
        }
      }

      if(argsSelDpto.descrClaseServ&&argsSelDpto.descrClaseServ!=="Todas..."){
        tipoqry += `, 'detalle.descrClaseServ': '${argsSelDpto.descrClaseServ}'`
      }

      tipoqry += `}},`

      argsBuscarPC = {tipoqry: `${tipoqry}
          {$project: {
            'recaudoEn': {$cond: { if: { $ifNull: [ "$descrRecurso", false ] }, then: "Tercero", else: "Oficina" } },
            'valorTotal': '$detalle.valorDetalle', 'contrato': 1,
            'descrRecurso': {$cond: { if: { $ifNull: [ "$descrRecurso", false ] }, then: '$descrRecurso', 
                                      else: '$cliente.dirmayor.ciudades.zonas.barrios.descrRecursoR' } }}},
          {$group: {_id: {contrato: '$contrato', recaudoEn: '$recaudoEn', descrRecurso: '$descrRecurso'}, 
              valorTotal: {$sum: '$valorTotal'}}},
          {"$unwind":"$_id"},
          {$project: {'recaudoEn': '$_id.recaudoEn', descrRecurso: '$_id.descrRecurso', valorTotal: '$valorTotal'}},
          {$group: {_id: {recaudoEn: '$recaudoEn', descrRecurso: '$descrRecurso'}, count: { $sum: 1 },
                valorTotal: {$sum: '$valorTotal'}}},
          {$unwind:"$_id"},
          {$sort: {_id: 1}},
          {$project: {_id: 0, totPagos: {$toInt: '$count'}, 'recaudoEn': '$_id.recaudoEn', 
              descrRecurso: '$_id.descrRecurso', valorTotal: {$toLong: '$valorTotal'}}}
      ]`}
      let movimRdo = []
      if(this.props.allPagoRtesGroup.allPagoRtesGroup){
        let {data} = await this.props.allPagoRtesGroup.refetch(argsBuscarPC)
        movimRdo = await data.allPagoRtesGroup
      }
// console.log(movimRdo)


      let listPagos = [], listGestion = []

      // console.log(clientesFact)
      // console.log(movimRdo)
      // console.log(argsSelDpto)

  //facturado por tercero
      listPagos = _(clientesFact)
        .groupBy('descrRecurso')
        .map((obj, key) => ({
          'descrRecurso': key,
          'valorFacturado': _.sumBy(obj, 'valorFacturado'),
          'valorFactura': _.sumBy(obj, 'valorFactura'),
          'numeroFras': _.sumBy(obj, 'totFras')
        }))
        .value()

      // console.log(listPagos)
//revisar calculo de clientesFact => esta mal ?
      listPagos.forEach((elemento, _id) => {
        argsUpd = {}
        argsUpd = {
          "descrRecurso": elemento.descrRecurso,
          "valorFacturado": elemento.valorFacturado,
          "saldoAnterior": elemento.valorFactura - elemento.valorFacturado,
          "valorFactura": elemento.valorFactura,
          "clientesFact": elemento.numeroFras,
          "recaudoTro": 0,
          "clientesTro": 0,
          "recaudoOf": 0,
          "clientesOf": 0,
        }
        listGestion.push(argsUpd)
      })
// console.log(listGestion)

//# DE CLIENTES QUE PAGARON POR TERCERO
      let listPagosRte = _(movimRdo)
      listPagos = []
      listPagosRte.forEach((elemento, _id) => {
        if(elemento.recaudoEn==="Tercero"){
          argsUpd = {}
          argsUpd = {
            "descrRecurso": elemento.descrRecurso,
            "valorFacturado": 0,
            "saldoAnterior": 0,
            "valorFactura": 0,
            "clientesFact": 0,
            "clientesTro": elemento.totPagos,
            "recaudoTro": elemento.valorTotal,
            "recaudoOf": 0,
            "clientesOf": 0
          }
          listPagos.push(argsUpd)
        }else{
          argsUpd = {}
          argsUpd = {
            "descrRecurso": elemento.descrRecurso,
            "valorFacturado": 0,
            "saldoAnterior": 0,
            "valorFactura": 0,
            "clientesFact": 0,
            "clientesOf": elemento.totPagos,
            "recaudoOf": elemento.valorTotal,
            "recaudoTro": 0,
            "clientesTro": 0,
          }
          listPagos.push(argsUpd)
        }
      })
// console.log(listPagos)

      listPagos.forEach((elemento, _id) => {
        // if(elemento.descrRecurso!=="null"){
          argsUpd = {}
          argsUpd = {
            "descrRecurso": elemento.descrRecurso,
            "valorFacturado": elemento.valorFacturado,
            "saldoAnterior": elemento.saldoAnterior,
            "valorFactura": elemento.valorFactura,
            "clientesFact": elemento.clientesFact,
            "recaudoTro": elemento.recaudoTro,
            "clientesTro": elemento.clientesTro,
            "recaudoOf": elemento.recaudoOf,
            "clientesOf": elemento.clientesOf,
          }
          listGestion.push(argsUpd)
        // } 
      })

//AGRUPAR TODA LA INF POR TERCERO
      listPagos = _(listGestion)
      .groupBy('descrRecurso')
      .map((obj, key) => ({
        'descrRecurso': key,
        "valorFacturado": _.sumBy(obj, 'valorFacturado'),
        "saldoAnterior": _.sumBy(obj, 'saldoAnterior'),
        "valorFactura": _.sumBy(obj, 'valorFactura'),
        "clientesFact": _.sumBy(obj, 'clientesFact'),
        "recaudoTro": _.sumBy(obj, 'recaudoTro'),
        "clientesTro": _.sumBy(obj, 'clientesTro'),
        "recaudoOf": _.sumBy(obj, 'recaudoOf'),
        "clientesOf": _.sumBy(obj, 'clientesOf'),
      }))
      .value()

      listPagos = _.orderBy(listPagos, ['descrRecurso'], ['asc'])
//       }
      this.setState({listPagos})
    }
      document.body.style.cursor = 'default'
    }
    // console.log(targetName)
    // console.log(this.props.permiteOpcion2)
    if(targetName==="pantalla"&&this.props.permiteOpcion2){
//EDAD DE MORA
      document.body.style.cursor = 'wait'
      // let fechaHoy = new Date()
      // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
      let argsUpd
      let errors = []
      let listEdad = []

      // console.log(argsDocum)
      this.setState({errors})
      if(errors.length===0){
        let argsBuscarCLR = `'estadoCliente': 'ACTIVO'`
        if(argsSelDpto.descrClaseServ&&argsSelDpto.descrClaseServ!=="Todas..."){
          if(argsBuscarCLR){argsBuscarCLR += `, `}
          argsBuscarCLR += `'tarifa.servicios.subclaseserv.claseserv.descrClaseServ': '${argsSelDpto.descrClaseServ}'`
        }
// console.log(argsSelDpto)
        // if(!argsSelDpto.descrDpto||argsSelDpto.descrDpto==="Todos..."){

        // }else{
        //   console.log("22")
        //   if(!argsSelDpto.nombreCiudad||argsSelDpto.nombreCiudad==="Todas..."){
        //     if(argsBuscarCLR){argsBuscarCLR += `, `}
        //     argsBuscarCLR += `'dirmayor.descrDpto': '${argsSelDpto.descrDpto}'`
        //   }else{
        //     if(argsBuscarCLR){argsBuscarCLR += `, `}
        //     argsBuscarCLR += `'dirmayor.descrDpto': '${argsSelDpto.descrDpto}', 'dirmayor.ciudades.nombreCiudad': '${argsSelDpto.nombreCiudad}'`
        //   }
        // }
        if(argsDocum.cicloFact&&argsDocum.cicloFact!=="Todos..."){
          if(argsBuscarCLR){argsBuscarCLR += `, `}
          argsBuscarCLR += `'cicloFact': '${argsDocum.cicloFact}'`
        }

        argsBuscarCLR = '{' + argsBuscarCLR + '}'
        argsBuscarCLR = {tipoqry: `[{$match: ${argsBuscarCLR}},
          {$project: {_id: 0, diasMora: 1, descrRecurso: '$dirmayor.ciudades.zonas.barrios.descrRecursoR',
            'rango': { $switch: {
                             branches: [
                                 { case: { $gte: [ "$diasMora", 90 ] }, then: "rango91" },
                                 { case: { $gte: [ "$diasMora", 61 ] }, then: "rango61_90" },
                                 { case: { $gte: [ "$diasMora", 31 ] }, then: "rango31_60" },
                                 { case: { $gte: [ "$diasMora", 1 ] }, then: "rango1_30" },
                                 { case: { $gte: [ "$diasMora", -99999 ] }, then: "rango0" }
                             ],
                             default: "5"
          }}}},
          {$group: {_id: {descrRecurso: '$descrRecurso', rango: '$rango'}, cuenta: { $sum: 1 }}},
          {"$unwind": "$_id"},
          {$sort: {_id: 1}},
          {$project: {_id: 0, descrRecurso: '$_id.descrRecurso', rango: '$_id.rango', cuenta: {$toInt: '$cuenta'}}}  
        ]`}
        let clientesClAc = []
        if(this.props.allClientesRtesGroup.allClientesRtesGroup){
          let {data} = await this.props.allClientesRtesGroup.refetch(argsBuscarCLR)
          clientesClAc = await data.allClientesRtesGroup
        }
// console.log(clientesClAc)

        argsBuscarCLR = `'estadoCliente': 'DESCONECTADO'`
        if(argsSelDpto.descrClaseServ&&argsSelDpto.descrClaseServ!=="Todas..."){
          if(argsBuscarCLR){argsBuscarCLR += `, `}
          argsBuscarCLR += `'tarifa.servicios.subclaseserv.claseserv.descrClaseServ': '${argsSelDpto.descrClaseServ}'`
        }
        
        // if(!argsSelDpto.descrDpto||argsSelDpto.descrDpto==="Todos..."){

        // }else{
        //   if(!argsSelDpto.nombreCiudad||argsSelDpto.nombreCiudad==="Todas..."){
        //     if(argsBuscarCLR){argsBuscarCLR += `, `}
        //     argsBuscarCLR += `'dirmayor.descrDpto': '${argsSelDpto.descrDpto}'`
        //   }else{
        //     if(argsBuscarCLR){argsBuscarCLR += `, `}
        //     argsBuscarCLR += `'dirmayor.descrDpto': '${argsSelDpto.descrDpto}', 'dirmayor.ciudades.nombreCiudad': '${argsSelDpto.nombreCiudad}'`
        //   }
        // }
        if(argsDocum.cicloFact&&argsDocum.cicloFact!=="Todos..."){
          if(argsBuscarCLR){argsBuscarCLR += `, `}
          argsBuscarCLR += `'cicloFact': '${argsDocum.cicloFact}'`
        }

        argsBuscarCLR = '{' + argsBuscarCLR + '}'
        argsBuscarCLR = {tipoqry: `[{$match: ${argsBuscarCLR}},
          {$project: {_id: 0, fechaUltDX: 1, descrRecurso: '$dirmayor.ciudades.zonas.barrios.descrRecursoR',
            fechahoy: { $toDate: {$dateToString: {format: '%Y-%m-%d', date: new Date(), timezone: 'America/Bogota'}} },
          }},
          {$project: {descrRecurso: 1,
            diasdifdx: {
              $let: {
                  vars: {pagueHastaDif: { $subtract: [ "$fechahoy", "$fechaUltDX" ]}},
                  in: { $toInt: {$divide: [ "$$pagueHastaDif", 86400000 ]} }
              }
            }
          }},
          {$addFields: {
            'rango': { $switch: {
              branches: [
                  { case: { $gte: [ "$diasdifdx", 90 ] }, then: "rango91" },
                  { case: { $gte: [ "$diasdifdx", 61 ] }, then: "rango61_90" },
                  { case: { $gte: [ "$diasdifdx", 31 ] }, then: "rango31_60" },
                  { case: { $gte: [ "$diasdifdx", 1 ] }, then: "rango1_30" },
                  { case: { $gte: [ "$diasdifdx", -99999 ] }, then: "rango0" }
              ],
              default: "5"
            }}
          }},
          {$group: {_id: {descrRecurso: '$descrRecurso', rango: '$rango'}, cuenta: { $sum: 1 }}},
          {"$unwind": "$_id"},
          {$sort: {_id: 1}},
          {$project: {_id: 0, descrRecurso: '$_id.descrRecurso', rango: '$_id.rango', cuenta: {$toInt: '$cuenta'}}}
        ]`}
        let clientesClDx = []
        if(this.props.allClientesRtesGroup.allClientesRtesGroup){
          let {data} = await this.props.allClientesRtesGroup.refetch(argsBuscarCLR)
          clientesClDx = await data.allClientesRtesGroup
        }
// console.log(clientesClDx)

        clientesClAc.forEach((elemento, _id) => {
          // console.log(elemento)
          let rango1 = 0, rango2 = 0, rango3 = 0, rango4 = 0
          if(elemento.rango==="rango0"){rango1=elemento.cuenta}
          if(elemento.rango==="rango1_30"){rango1=elemento.cuenta}
          if(elemento.rango==="rango31_60"){rango2=elemento.cuenta}
          if(elemento.rango==="rango61_90"){rango3=elemento.cuenta}
          if(elemento.rango==="rango91"){rango4=elemento.cuenta}

// console.log(elemento.contrato)
          argsUpd = {}
          argsUpd = {
            "descrRecurso": elemento.descrRecurso,
            "rango1Ac": rango1,
            "rango2Ac": rango2,
            "rango3Ac": rango3,
            "rango4Ac": rango4,
            "rango1DX": 0,
            "rango2DX": 0,
            "rango3DX": 0,
            "rango4DX": 0,
          }
          listEdad.push(argsUpd)
        })
// console.log(listEdad)

        clientesClDx.forEach((elemento, _id) => {
          // console.log(elemento)
          let rango1 = 0, rango2 = 0, rango3 = 0, rango4 = 0
          if(elemento.rango==="rango0"){rango1=elemento.cuenta}
          if(elemento.rango==="rango1_30"){rango1=elemento.cuenta}
          if(elemento.rango==="rango31_60"){rango2=elemento.cuenta}
          if(elemento.rango==="rango61_90"){rango3=elemento.cuenta}
          if(elemento.rango==="rango91"){rango4=elemento.cuenta}

// console.log(elemento.contrato)
          argsUpd = {}
          argsUpd = {
            "descrRecurso": elemento.descrRecurso,
            "rango1DX": rango1,
            "rango2DX": rango2,
            "rango3DX": rango3,
            "rango4DX": rango4,
            "rango1Ac": 0,
            "rango2Ac": 0,
            "rango3Ac": 0,
            "rango4Ac": 0,
          }
          listEdad.push(argsUpd)
        })
// console.log(listEdad)

  //facturado por tercero
          listEdad = _(listEdad)
            .groupBy('descrRecurso')
            .map((obj, key) => ({
              'descrRecurso': key,
              'rango1Ac': _.sumBy(obj, 'rango1Ac'),
              'rango2Ac': _.sumBy(obj, 'rango2Ac'),
              'rango3Ac': _.sumBy(obj, 'rango3Ac'),
              'rango4Ac': _.sumBy(obj, 'rango4Ac'),
              'rango1DX': _.sumBy(obj, 'rango1DX'),
              'rango2DX': _.sumBy(obj, 'rango2DX'),
              'rango3DX': _.sumBy(obj, 'rango3DX'),
              'rango4DX': _.sumBy(obj, 'rango4DX')
            }))
            .value()

            listEdad = _.orderBy(listEdad, ['descrRecurso'], ['asc'])
  //       }
            this.setState({listEdad})
        }
        document.body.style.cursor = 'default'
      }
    if(targetName==="pdf"){
      var doc = new jsPDF({orientation: 'l', unit: 'mm', format: 'letter'})
      doc.setFontSize(14);
      doc.setFontType("bold");
      let texto1 = this.props.empresa.empresaRazonSocial
      let texto2 = "GESTION DE RECAUDO"
      let texto3 = ""
      doc.text(texto1, 108, 20, 'center')
      doc.setFontSize(12);
      doc.text(texto2, 108, 30, 'center')
      doc.setFontSize(10);
      doc.text(texto3, 108, 40, 'center')
  
      var source = document.getElementById("tabla");
      doc.autoTable({startY: 45,
                      tableLineColor: "blue",
                      tableLineWidth: 0.1,
                      styles: {
                        // font: 'Calibri',
                        fontSize: 10,
                        lineColor: "black",
                        lineWidth: 0.1
                      },
                      headStyles: {
                        fillColor: "#bdc3c7",
                        textColor: "black",
                        fontSize: 12
                      },
                      bodyStyles: {
                        fillColor: "#E9E4F0",
                        textColor: "black"
                      },
                      alternateRowStyles: {
                        fillColor: "white",
                        textColor: "black"
                      },
                      html: source,
                      margin: {top: 10, left: 2, right: 2},})
      // let finalY = doc.previousAutoTable.finalY; //para traer posicion final de la tabla
      // doc.text("TOTAL", 50, finalY + 15);
      doc.autoPrint({variant: 'non-conform'});
      // doc.output('dataurlnewwindow'); //abre el pdf en una nueva ventana // OJOOO YA NO FUNCIONA
      // => UTILIZAR
      const pdfBlob = doc.output('blob');
      const url = URL.createObjectURL(pdfBlob);
      window.open(url);
      // doc.save('movdiario.pdf')
    }
    if(targetName==="excel"){
      var tableToExcel = (function() {
        var tmpElemento = document.createElement('a')
  //window.btoa => Encode a string in base-64
        var uri = 'data:application/vnd.ms-excel;base64,'
          , template = `<html xmlns:o="urn:schemas-microsoft-com:office:office"
                              xmlns:x="urn:schemas-microsoft-com:office:excel">
                          <head>
                            <!--[if gte mso 9]>
                              <xml><x:ExcelWorkbook>
                                    <x:ExcelWorksheets>
                                      <x:ExcelWorksheet>
                                        <x:Name>{worksheet}</x:Name>
                                        <x:WorksheetOptions><x:DisplayGridlines/>
                                        </x:WorksheetOptions>
                                      </x:ExcelWorksheet>
                                    </x:ExcelWorksheets>
                                  </x:ExcelWorkbook>
                              </xml>
                            <![endif]-->
                          </head>
                          <body><table>{table}</table></body>
                        </html>`
          , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
          , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
        return function(table, hoja) {
          if (!table.nodeType) table = document.getElementById(table)
          var ctx = {worksheet: hoja || 'Worksheet', table: table.innerHTML}
          tmpElemento.href = uri + base64(format(template, ctx))
          tmpElemento.download = 'gesrdo.xls';
          tmpElemento.click();
        }
      })()
  
      tableToExcel('tabla', 'gesrdo')
    }
    // console.log("listooooo")
  }
  
  componentDidUpdate(prevProps){
    if(this.props.permiteOpcion1){
      let miLista = document.getElementById("miLista");
      if(!miLista.options[miLista.selectedIndex].value&&this.props.argsSelDpto.descrDpto&&this.props.argsSelDpto.descrDpto!=="Todos..."){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['codigoDpto'] = ""
        argsSelDpto['descrDpto'] = "Todos..."
        argsSelDpto['_id'] = ""
        argsSelDpto['nombreCiudad'] = "Todas..."
        argsSelDpto['codigoCiudad'] = ""
        argsSelDpto['codigoCiudadInterno'] = ""
        argsSelDpto['codBarrasRdo'] = ""
        this.setState({argsSelDpto})

        const argsDocum = this.state.argsDocum
        argsDocum['descrDpto'] = "Todos..."
        this.setState({argsDocum});
      }

      if(this.props.argsSelDpto.codigoCiudad!==undefined&&this.props.argsSelDpto.codigoCiudad!==""){
        miLista = document.getElementById("miLista1");
        if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoCiudad){
          const argsSelDpto = this.state.argsSelDpto
          argsSelDpto['nombreCiudad'] = "Todas..."
          argsSelDpto['codigoCiudad'] = ""
          argsSelDpto['codigoCiudadInterno'] = ""
          argsSelDpto['codBarrasRdo'] = ""
          this.setState({argsSelDpto})
        }
      }
      if(this.props.argsSelDpto.descrDpto!==this.state.argsDocum.descrDpto||
          this.props.argsSelDpto.nombreCiudad!==this.state.argsDocum.nombreCiudad){
        const argsDocum = this.state.argsDocum
        argsDocum.descrDpto = this.props.argsSelDpto.descrDpto
        argsDocum.nombreCiudad = this.props.argsSelDpto.nombreCiudad
        this.setState({argsDocum});
        this.setState({argsSelDpto: this.props.argsSelDpto})
        let listPagos = [], listEdad = []
        this.setState({listPagos, listEdad})
      }
    }

    // if(this.props.argsSelDpto!==prevProps.argsSelDpto){
    //   this.setState({argsSelDpto: this.props.argsSelDpto})
    // }
  }

  render(){
    const {argsDocum, listPagos, listEdad, errors} = this.state;
    const a15200101 = this.props.autorizacUA.findIndex( autorizac => autorizac === "15200101" );
    const a15200105 = this.props.autorizacUA.findIndex( autorizac => autorizac === "15200105" );
    const a15200501 = this.props.autorizacUA.findIndex( autorizac => autorizac === "15200501" );
    const a15200505 = this.props.autorizacUA.findIndex( autorizac => autorizac === "15200505" );

    let listCiu = []
    if(this.props.permiteOpcion1){
      if(this.props.codigoCiudadUA!=="Todas..."){
        let dpto = document.getElementById("miLista");
        if(dpto){
          dpto.options.selectedIndex = 0
        }
      }

      let colecc = selciudad(this.props.list3, this.props.argsSelDpto, this.props.codigoCiudadUA)
      listCiu = colecc.listCiu
    }

    let procMes = []
    this.props.list1.forEach((elemento, i) => {
      if(this.props.codigoCiudadUA!=="Todas..."){
        // console.log(i, elemento)
        // console.log(i, this.props.argsSelDpto)
        if(elemento.fechaCreate.substr(0, 10)>=argsDocum.desdeF&&elemento.fechaCreate.substr(0, 10)<=argsDocum.hastaF&&
            elemento.descrDpto===this.props.argsSelDpto.descrDpto&&
            elemento.nombreCiudad===this.props.argsSelDpto.nombreCiudad){
          procMes.push(elemento)
        }
      }else{
        if(elemento.fechaCreate.substr(0, 10)>=argsDocum.desdeF&&elemento.fechaCreate.substr(0, 10)<=argsDocum.hastaF){
          procMes.push(elemento)
        }
      }
    })

    let titOpcion = "Gestión recaudo"
    if(this.props.permiteOpcion2){
      titOpcion = "Edad de mora"
    }

// console.log(listPagos)
// console.log(procMes)
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large money yellow icon"></i>
          {titOpcion}
        </button>

        {this.props.permiteOpcion1 &&
        <div>
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1" onSubmit={(ev)=>this.handleSubmit(ev, argsDocum, this.props.argsSelDpto)}>
              <div>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <h1 style={{color: '#2C7744'}}>Gestión recaudo</h1>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <p style={{color: '#2C7744', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Facturación
                </p>

                <div className="ui three column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '20%'}}>
                      <p style={{color: '#302b63', fontSize: '1em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Procesos fact desde
                      </p>
                      <Form.Field>
                        <input style={this.props.styles.input} type='date' name="desdeF" id="desdeF" value={argsDocum.desdeF} onChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '20%'}}>
                      <p style={{color: '#302b63', fontSize: '1em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Hasta
                      </p>
                      <Form.Field>
                        <input style={this.props.styles.input} type='date' name="hastaF" id="hastaF" value={argsDocum.hastaF} onChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '60%'}}>
                    <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Procesos de facturación
                    </p>
                    <Form.Field>
                      <ListaPF styles={this.props.styles} list={procMes} handleChange={this.handleChange}/>
                    </Form.Field>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <hr></hr>
                <p style={{color: '#2C7744', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Recaudo
                </p>

                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '25%'}}>
                      <p style={{color: '#302b63', fontSize: '1em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Recaudo desde
                      </p>
                      <Form.Field>
                        <input style={this.props.styles.input} type='date' name="desde" id="desde" value={argsDocum.desde} onChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '25%'}}>
                      <p style={{color: '#302b63', fontSize: '1em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Hasta
                      </p>
                      <Form.Field>
                        <input style={this.props.styles.input} type='date' name="hasta" id="hasta" value={argsDocum.hasta} onChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <hr></hr>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Departamento
                      </p>
                      <Form.Field>
                        <ListaDe list={this.props.list3} styles={this.props.styles}
                            handleLista={this.props.handleLista} codigoCiudadUA={this.props.codigoCiudadUA}
                            codigoDptoUA={this.props.codigoDptoUA}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Ciudad
                      </p>
                      <Form.Field>
                        <ListaCi list={listCiu} styles={this.props.styles}
                          handleLista1={this.props.handleLista1} argsSelDpto={this.props.argsSelDpto}
                          codigoCiudadUA={this.props.codigoCiudadUA}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Clase
                      </p>
                      <Form.Field>
                        <Lista styles={this.props.styles} list={this.props.list2} handleLista4={this.props.handleLista4}
                          argsSelDpto={this.props.argsSelDpto} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Ciclo de facturación
                      </p>
                      <Form.Field>
                        <ListaCF styles={this.props.styles} list={this.props.listaCF} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                <hr></hr>
                {/* <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                  Totales:  Pagos:&nbsp;
                  {totalPagos}&nbsp;&nbsp;&nbsp;&nbsp;
                  Valor:&nbsp;
                  {valorTotal}
                </p> */}

                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '34%'}}>
                      <Button id="pantalla" name="pantalla" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, this.props.argsSelDpto)} fluid>
                        VER EN PANTALLA
                      </Button>
                    </div>
                    {a15200101!==-1 &&
                    <div className="column" style={{width: '33%'}}>
                      <Button id="excel" name="excel" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, this.props.argsSelDpto)} fluid>
                        ARCHIVO EXCEL
                      </Button>
                    </div>
                    }
                    {a15200105!==-1 &&
                    <div className="column" style={{width: '33%'}}>
                      <Button id="pdf" name="pdf" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, this.props.argsSelDpto)} fluid>
                        ARCHIVO PDF
                      </Button>
                    </div>
                    }
                  </div>
                </div>
                <hr></hr>
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                      <tr className=''>
                        <th rowSpan='2' className=''>Tercero</th>
                        <th colSpan='4' className='center aligned'>Facturación</th>
                        <th colSpan='4' className='center aligned'>Recaudo</th>
                      </tr>
                      <tr className=''>
                        <th className='right aligned'>$ Facturado</th>
                        <th className='right aligned'>$ Saldo ant</th>
                        <th className='right aligned'>$ Total Fact</th>
                        <th className='right aligned'># Fact</th>
                        <th className='right aligned'>$ Rdo tercero</th>
                        <th className='right aligned'># Clientes</th>
                        <th className='right aligned'>$ Rdo ofic</th>
                        <th className='right aligned'># Clientes</th>
                      </tr>
                    </thead>
                    <ListaRdo list={listPagos}/>
                  </table>
              </div>
              
              {
                errors.length?<Message negative header="Los siguientes errores:"
                list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
              }

            </Form>
          </div>
        </div>
        }

        {this.props.permiteOpcion2 &&
        <div>
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1" onSubmit={(ev)=>this.handleSubmit(ev, argsDocum, this.props.argsSelDpto)}>
              <div>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <h1 style={{color: '#2C7744'}}>Edad de mora</h1>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '50%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Clase
                      </p>
                      <Form.Field>
                        <Lista styles={this.props.styles} list={this.props.list2} handleLista4={this.props.handleLista4}
                          argsSelDpto={this.props.argsSelDpto} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                    <div className="column" style={{width: '50%'}}>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Ciclo de facturación
                      </p>
                      <Form.Field>
                        <ListaCF styles={this.props.styles} list={this.props.listaCF} handleChange={this.handleChange}/>
                      </Form.Field>
                    </div>
                  </div>
                </div>
                <hr></hr>
                <div className="ui two column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '34%'}}>
                      <Button id="pantalla" name="pantalla" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, this.props.argsSelDpto)} fluid>
                        VER EN PANTALLA
                      </Button>
                    </div>
                    {a15200501!==-1 &&
                    <div className="column" style={{width: '33%'}}>
                      <Button id="excel" name="excel" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, this.props.argsSelDpto)} fluid>
                        ARCHIVO EXCEL
                      </Button>
                    </div>
                    }
                    {a15200505!==-1 &&
                    <div className="column" style={{width: '33%'}}>
                      <Button id="pdf" name="pdf" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev, argsDocum, this.props.argsSelDpto)} fluid>
                        ARCHIVO PDF
                      </Button>
                    </div>
                    }
                  </div>
                </div>
                <hr></hr>
                  <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th rowSpan='2' className=''>Tercero</th>
                        <th colSpan='4' className='center aligned'>Activos con mora entre</th>
                        <th colSpan='4' className='center aligned'>DX desde</th>
                      </tr>
                      <tr className=''>
                        <th className='center aligned'>0-30</th>
                        <th className='center aligned'>31-60</th>
                        <th className='center aligned'>61-90</th>
                        <th className='center aligned'>91-</th>
                        <th className='center aligned'>0-30</th>
                        <th className='center aligned'>31-60</th>
                        <th className='center aligned'>61-90</th>
                        <th className='center aligned'>91-</th>
                      </tr>
                    </thead>
                    <ListaEdad list={listEdad}/>
                  </table>
              </div>
              
              {
                errors.length?<Message negative header="Los siguientes errores:"
                list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
              }

            </Form>
          </div>
        </div>
        }
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: argsBuscarCL}}}),
  graphql(queries.query.allClientesRtesGroup, {name:'allClientesRtesGroup', options: (props) => {return {variables: argsBuscarCLRte}}}),
  
  graphql(queries.query.allFactRtesGroup, {name:'allFactRtesGroup', options: (props) => {return {variables: argsBuscarFact}}}),
  
  graphql(queries.query.allPagoRtesGroup, {name:'allPagoRtesGroup', options: (props) => {return {variables: argsBuscarPC}}}),

  graphql(queries.query.allMovTodos, {name:'allMovTodos', options: (props) => {return {variables: argsBuscarMC}}}),

  )(RtesGesTro2)
